import { render, staticRenderFns } from "./LearningOutcomesMapper.vue?vue&type=template&id=66dfd126"
import script from "./LearningOutcomesMapper.vue?vue&type=script&lang=js"
export * from "./LearningOutcomesMapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports